import { COMMON_STATE_KEY } from './common-reducer';

export const getAllSpecialties = (state: any) => state[COMMON_STATE_KEY].specialties;
export const getEquipment = (state: any) =>
  state[COMMON_STATE_KEY].equipment?.map(({ id, fullName }) => ({
    id,
    name: fullName,
  }));
